// funkcinalita pro práci s URL adresami

export function getServerUrl() {
  if (window.location.hostname === "localhost") {
    return "http://localhost:44350";
  }else if (window.location.hostname === "test.rozvozy.sk") {
    return "https://testapi.rozvozy.sk";
  } 
  else {
    return "https://api.rozvozy.sk";
  }
}

export const API_BASE_URL = getServerUrl() + "/api";

export const LOGIN_URL = getServerUrl() + "/api/login";
export const CHANGE_INITIAL_PASSWORD_URL = getServerUrl() + "/api/change-initial-password";

export const REGISTER_URL = getServerUrl() + "/api/register";

export const IS_AUTHENTICATED_URL = getServerUrl() + "/api/is-authenticated";

export const ERROR_LOG_URL = getServerUrl() + "/api/errorlog";

export const VERIFY_PHONE_URL = getServerUrl() + "/api/verify-phone";

export const RESEND_SMS_URL = getServerUrl() + "/api/resend-sms";

export const FRONTEND_ERROR_LOG_URL = getServerUrl() + "/api/frontend-errorlog";

export const COMPANY_URL = getServerUrl() + "/api/company";

// Ktora prevadzka sa zobrazuje (TenantContext). Prevadzku urci backend
// z X-Company-Slug (request interceptor) alebo z Origin pri vlastnej domene.
export const TENANT_RESOLVE_URL = getServerUrl() + "/api/tenant/resolve";
export const GET_PUBLIC_DELIVERY_SCHEDULES_URL = getServerUrl() + "/api/delivery-schedules-public";

// SuperAdmin – správa všetkých firiem (ignoruje COMPANY_ID z .env)
export const SUPERADMIN_COMPANIES_URL = getServerUrl() + "/api/superadmin/companies";
export const SUPERADMIN_UPDATE_COMPANY_URL = (id) => getServerUrl() + `/api/superadmin/companies/${id}`;
export const SUPERADMIN_DELETE_COMPANY_URL = (id) => getServerUrl() + `/api/superadmin/companies/${id}`;

export const GET_USERS_URL = getServerUrl() + "/api/users";
export const GET_ADMIN_CUSTOMERS_URL = getServerUrl() + "/api/customers";
export const CREATE_ADMIN_CUSTOMER_URL = getServerUrl() + "/api/customers";
export const UPDATE_ADMIN_CUSTOMER_URL = (id) => getServerUrl() + `/api/customers/${id}`;

export const GET_DEBTORS_URL = getServerUrl() + "/api/manager/debtors";
export const GET_DEBT_HISTORY_URL = (id) => getServerUrl() + `/api/manager/debtors/${id}/orders`;
export const POST_DEBT_PAYMENT_URL = (id) => getServerUrl() + `/api/manager/debtors/${id}/payment`;
export const POST_BULK_DEBT_PAYMENT_URL = getServerUrl() + "/api/manager/debtors/bulk-pay";
export const GET_ORDER_BALANCE_SNAPSHOT_URL = (orderId) => getServerUrl() + `/api/manager/orders/${orderId}/balance-snapshot`;

export const VERIFY_USER_URL = getServerUrl() + "/api/user/verify";

export const DELETES_USER_URL = (id) => getServerUrl() + `/api/users/${id}`;

export const UPDATE_USER_URL = getServerUrl() + "/api/updateUser";

// profile
export const PROFILE_URL = getServerUrl() + "/api/profile";
export const CHANGE_PASSWORD_URL = getServerUrl() + "/api/change-password";

// contact form
export const CONTACT_URL = getServerUrl() + "/api/send-contact-email";

export const GET_ROUTES_URL = getServerUrl() + "/api/routes";
export const DELETE_ROUTE_URL = (id) => getServerUrl() + `/api/routes/${id}`;
export const GET_DRIVERS_URL = getServerUrl() + "/api/drivers";

export const GET_PRICE_LISTS_URL = getServerUrl() + "/api/cenniky";
export const CREATE_PRICE_LIST_URL = getServerUrl() + "/api/cenniky";
export const UPDATE_PRICE_LIST_URL = (id) => getServerUrl() + `/api/cenniky/${id}`;
export const DELETE_PRICE_LIST_URL = (id) => getServerUrl() + `/api/cenniky/${id}`;

export const GET_PRICE_RATES_URL = getServerUrl() + "/api/ceny";
export const GET_STANDARD_MENU_PRICE_URL = (kodMenu, date) => {
  const qs = new URLSearchParams({ kod_menu: kodMenu });
  if (date) qs.set("date", date);
  return getServerUrl() + `/api/ceny/lookup?${qs.toString()}`;
};
export const CREATE_PRICE_RATE_URL = getServerUrl() + "/api/ceny";
export const UPDATE_PRICE_RATE_URL = (id) => getServerUrl() + `/api/ceny/${id}`;
export const DELETE_PRICE_RATE_URL = (id) => getServerUrl() + `/api/ceny/${id}`;

export const GET_MENU_ITEMS_URL = getServerUrl() + "/api/menu-items";
export const DELETE_MENU_ITEM_URL = (id) => getServerUrl() + `/api/menu-items/${id}`;
export const GET_MENU_ITEM_PHOTO_URL = (id) => getServerUrl() + `/api/menu-items/${id}/photo`;
export const GET_TAGS_URL = (q) => q ? getServerUrl() + `/api/tags?q=${encodeURIComponent(q)}` : getServerUrl() + "/api/tags";

export const GET_DAILY_MENU_URL = (params = {}) => {
  const base = getServerUrl() + "/api/daily-menu";
  const qs = new URLSearchParams();
  if (params.date_from) qs.set("date_from", params.date_from);
  if (params.date_to)   qs.set("date_to",   params.date_to);
  const qsStr = qs.toString();
  return qsStr ? `${base}?${qsStr}` : base;
};
// Admin cita denne menu z vlastnej cesty -- verejne GET /api/daily-menu
// nevracia planned_daily_limit (backend, F3).
export const GET_ADMIN_DAILY_MENU_URL = (params = {}) =>
  GET_DAILY_MENU_URL(params).replace("/api/daily-menu", "/api/admin/daily-menu");
export const SAVE_DAILY_MENU_URL   = getServerUrl() + "/api/daily-menu";
export const PATCH_DAILY_MENU_URL  = (id) => getServerUrl() + `/api/daily-menu/${id}`;
export const DELETE_DAILY_MENU_URL = (id) => getServerUrl() + `/api/daily-menu/${id}`;

// ─── Manager / Dashboard ──────────────────────────────────────────────────────
export const GET_MANAGER_DAILY_MENU_URL = (fromDate, toDate) => {
  const from = fromDate;
  const to = toDate || fromDate;
  return getServerUrl() + `/api/manager/daily-menu?date_from=${from}&date_to=${to}`;
};
export const PATCH_MANAGER_DAILY_MENU_URL = (id) =>
  getServerUrl() + `/api/manager/daily-menu/${id}`;
export const SAVE_MANAGER_DAILY_MENU_URL = getServerUrl() + '/api/manager/daily-menu';
export const DELETE_MANAGER_DAILY_MENU_URL = (id) =>
  getServerUrl() + `/api/manager/daily-menu/${id}`;

export const GET_MANAGER_ORDERS_URL = (fromDate, toDate) => {
  const from = fromDate;
  const to = toDate || fromDate;
  return getServerUrl() + `/api/manager/orders?fromDate=${from}&toDate=${to}`;
};
export const GET_ALL_ORDERS_FOR_EXPORT_URL = getServerUrl() + '/api/manager/orders/all-for-export';
export const CREATE_ORDER_URL  = getServerUrl() + '/api/manager/orders';
export const PATCH_ORDER_URL   = (id) => getServerUrl() + `/api/manager/orders/${id}`;

export const GET_MANAGER_ROUTES_URL   = getServerUrl() + '/api/manager/routes';
// Zaujímavosti za celú históriu -- nezávisia od dátumového filtra Prehľadu.
export const GET_MANAGER_OVERVIEW_INSIGHTS_URL = getServerUrl() + '/api/manager/overview-insights';
export const GET_MANAGER_PRICE_LISTS_URL = getServerUrl() + '/api/manager/price-lists';
export const GET_MANAGER_ORDER_PRICES_URL = (params = {}) => {
  const qs = new URLSearchParams(params);
  return getServerUrl() + `/api/manager/order-prices?${qs.toString()}`;
};

export const SEARCH_CUSTOMERS_URL    = (q) =>
  getServerUrl() + `/api/manager/customers/search?q=${encodeURIComponent(q)}`;
export const GET_CUSTOMER_ADDRESSES_URL = (id) =>
  getServerUrl() + `/api/manager/customers/${id}/addresses`;
export const CREATE_CUSTOMER_URL     = getServerUrl() + '/api/manager/customers';
export const PATCH_CUSTOMER_URL      = (id) => getServerUrl() + `/api/manager/customers/${id}`;
export const GET_ADDRESS_BY_CODE_URL = (code) =>
  getServerUrl() + `/api/manager/address-by-code?code=${encodeURIComponent(code)}`;
export const CREATE_ADDRESS_URL      = getServerUrl() + '/api/manager/addresses';
export const PATCH_ADDRESS_URL       = (id) => getServerUrl() + `/api/manager/addresses/${id}`;
export const GET_ROUTE_FOR_ADDRESS_URL = (addressId) =>
  getServerUrl() + `/api/manager/orders/route-for-address?address_id=${addressId}`;

// ─── Driver ───────────────────────────────────────────────────────────────────
export const GET_DRIVER_ROUTES_URL     = getServerUrl() + '/api/driver/routes';
export const GET_DRIVER_ALL_ROUTES_URL = getServerUrl() + '/api/driver/all-routes';
export const GET_DRIVER_ORDERS_URL = (date, routeId) =>
  getServerUrl() + `/api/driver/orders?date=${date}&route_id=${routeId}`;
export const DELIVER_ORDER_URL = (id) =>
  getServerUrl() + `/api/driver/orders/${id}/deliver`;
export const UPDATE_PAYMENT_URL = (id) =>
  getServerUrl() + `/api/driver/orders/${id}/payment`;

// --- Admin: delivery schedules ---
export const GET_DELIVERY_SCHEDULES_URL = getServerUrl() + "/api/delivery-schedules";
export const CREATE_DELIVERY_SCHEDULES_URL = getServerUrl() + "/api/delivery-schedules";
export const UPDATE_DELIVERY_SCHEDULES_URL = getServerUrl() + "/api/delivery-schedules";
export const DELETE_DELIVERY_SCHEDULES_URL = (validFrom) =>
  getServerUrl() + `/api/delivery-schedules/${encodeURIComponent(validFrom)}`;

// ─── Podpora / hlásenia chýb (ticketing) ──────────────────────────────────────
export const CREATE_SUPPORT_TICKET_URL = getServerUrl() + "/api/support-tickets";
export const GET_SUPPORT_TICKETS_URL = (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined),
  ).toString();
  return getServerUrl() + `/api/support-tickets${qs ? `?${qs}` : ""}`;
};
export const GET_SUPPORT_TICKET_URL = (id) => getServerUrl() + `/api/support-tickets/${id}`;
export const PATCH_SUPPORT_TICKET_STATUS_URL = (id) =>
  getServerUrl() + `/api/support-tickets/${id}/status`;

// ─── Realtime (SSE) ───────────────────────────────────────────────────────────
// EventSource nevie posielat vlastne hlavicky, takze sa stream autentifikuje
// kratkodobym listkom v query. Listok sa vypyta normalnym POST-om s Bearer
// tokenom.
// --- Platformova sprava (rozvozy.sk/sprava) ---
export const PLATFORM_LOGIN_URL = getServerUrl() + "/api/platform/login";
export const PLATFORM_IS_AUTHENTICATED_URL = getServerUrl() + "/api/platform/is-authenticated";
export const PLATFORM_ACT_AS_URL = getServerUrl() + "/api/superadmin/act-as";
export const PLATFORM_COMPANY_DOMAINS_URL = (companyId) =>
  getServerUrl() + `/api/superadmin/companies/${companyId}/domains`;
export const PLATFORM_VERIFY_DOMAIN_URL = (id) => getServerUrl() + `/api/superadmin/domains/${id}/verify`;
export const PLATFORM_DELETE_DOMAIN_URL = (id) => getServerUrl() + `/api/superadmin/domains/${id}`;
export const PLATFORM_COMPANY_USERS_URL = (companyId) =>
  getServerUrl() + `/api/superadmin/companies/${companyId}/users`;
export const PLATFORM_BLOCK_USER_URL = (id) => getServerUrl() + `/api/superadmin/users/${id}/block`;
export const PLATFORM_COMPANY_REQUESTS_URL = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.typ) qs.set("typ", params.typ);
  if (params.status) qs.set("status", params.status);
  const qsStr = qs.toString();
  return getServerUrl() + "/api/superadmin/company-requests" + (qsStr ? `?${qsStr}` : "");
};
export const PLATFORM_APPROVE_REQUEST_URL = (id) =>
  getServerUrl() + `/api/superadmin/company-requests/${id}/approve`;
export const PLATFORM_REJECT_REQUEST_URL = (id) =>
  getServerUrl() + `/api/superadmin/company-requests/${id}/reject`;

// Verejny formular ziadosti o prevadzku (marketing rozvozy.sk)
export const COMPANY_REQUEST_URL = getServerUrl() + "/api/company-requests";
// krok 1 ziadosti: jednorazovy kod na overenie e-mailu
export const COMPANY_REQUEST_EMAIL_CODE_URL = getServerUrl() + "/api/company-requests/email-code";

export const REALTIME_TICKET_URL = getServerUrl() + "/api/events/ticket";
export const REALTIME_STREAM_URL = (ticket) =>
  getServerUrl() + `/api/events/stream?ticket=${encodeURIComponent(ticket)}`;

// ─── Zakaznicke objednavanie ──────────────────────────────────────────────────
// Registracia ma dva kroky: najprv kod na e-mail, potom ucet aj s adresami.
export const REGISTER_EMAIL_CODE_URL = getServerUrl() + "/api/register/email-code";
// Zakaznik pozvany obsluhou si nastavuje heslo na UZ EXISTUJUCOM ucte.
export const REGISTER_INVITE_CONFIRM_URL = getServerUrl() + "/api/register/invite-confirm";

// Reset hesla e-mailom -- jeden tok pre zakaznikov aj zamestnancov.
export const FORGOT_PASSWORD_EMAIL_CODE_URL = getServerUrl() + "/api/forgot-password/email-code";
export const FORGOT_PASSWORD_RESET_URL = getServerUrl() + "/api/forgot-password/confirm";

// Doplnenie alebo zmena vlastneho e-mailu (s overenim kodom).
export const PROFILE_EMAIL_CODE_URL = getServerUrl() + "/api/profile/email/code";
export const PROFILE_EMAIL_CONFIRM_URL = getServerUrl() + "/api/profile/email";

// Vsetko pre objednavaciu obrazovku naraz: dni, menu a ceny.
// Verejne; s prihlasenim vrati ceny podla cennika zakaznika.
export const ORDER_CONFIG_URL = getServerUrl() + "/api/order-config";

export const CUSTOMER_ORDERS_URL = getServerUrl() + "/api/customer/orders";
export const CUSTOMER_ORDER_URL = (id) => getServerUrl() + `/api/customer/orders/${id}`;
export const CUSTOMER_ORDER_CANCEL_URL = (id) =>
  getServerUrl() + `/api/customer/orders/${id}/cancel`;

// Karta zakaznika v sprave: pozvanie na web a rucne sparovanie uctov.
export const CUSTOMER_INVITE_URL = (id) =>
  getServerUrl() + `/api/manager/customers/${id}/invite`;
export const CUSTOMER_POSSIBLE_MATCHES_URL = (id) =>
  getServerUrl() + `/api/manager/customers/${id}/possible-matches`;
export const CUSTOMER_MERGE_URL = (id) =>
  getServerUrl() + `/api/manager/customers/${id}/merge`;

// Profil zakaznika: vlastne udaje, saldo a sprava adries.
export const CUSTOMER_PROFILE_URL = getServerUrl() + "/api/customer/profile";
export const CUSTOMER_ADDRESSES_URL = getServerUrl() + "/api/customer/addresses";
export const CUSTOMER_ADDRESS_URL = (id) => getServerUrl() + `/api/customer/addresses/${id}`;

// Nastavenia online objednavok (R35) a udaje predavajuceho (R36).
// Zapnutie a pauzu smie aj manazer, udaje predavajuceho len admin -- preto
// su to dve rozne cesty s roznou autorizaciou.
export const ONLINE_ORDERS_SETTINGS_URL = getServerUrl() + "/api/manager/online-orders";
// Tá istá cesta slúži dvom veciam podľa metódy: GET je verejný (údaje
// predávajúceho do VOP, R6), PATCH smie len admin.
export const SELLER_DETAILS_URL = getServerUrl() + "/api/seller-details";

// Súhlas s aktuálnym znením podmienok (R6).
export const TERMS_STATUS_URL = getServerUrl() + "/api/customer/terms-status";
export const ACCEPT_TERMS_URL = getServerUrl() + "/api/customer/accept-terms";
